import '@emotion/react';
import { borderRadius, colors, elevation, spacing, typography } from './design-tokens';

export interface AdsTheme {
  colors: typeof colors;
  typography: typeof typography;
  spacing: typeof spacing;
  borderRadius: typeof borderRadius;
  elevation: typeof elevation;
}

declare module '@emotion/react' {
  export interface Theme extends AdsTheme {}
}

export const adsTheme: AdsTheme = {
  colors,
  typography,
  spacing,
  borderRadius,
  elevation,
};
